(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["enquiry-measurement"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const config = document.querySelector('[data-enquiry-measurement]');
    if (!config || config.dataset.initialized) return;
    config.dataset.initialized = 'true';
    const preview = config.dataset.themeRole !== 'main';
    const debug = preview && new URLSearchParams(location.search).get('laserco_tracking_debug') === '1';
    const recentClicks = new WeakMap();
    const pendingKey = 'laserco_enquiry_pending_v1';
    let panel;
    if (debug) {
      panel = document.createElement('output');
      panel.setAttribute('aria-label', 'Enquiry tracking preview');
      panel.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:999999;max-width:min(430px,90vw);padding:12px;background:#fff;color:#111;border:2px solid #155e4a;font:12px/1.5 monospace;white-space:pre-wrap;pointer-events:none';
      panel.textContent = 'Enquiry tracking preview: ready. Test events are not sent.';
      document.body.appendChild(panel);
    }
    const allowed = () => {
      try {
        return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
      } catch (_) {
        return false;
      }
    };
    const emit = (name, extra) => {
      const data = {
        schema_version: 1,
        page_type: config.dataset.pageType,
        page_path: config.dataset.pagePath,
        product_id: config.dataset.productId || undefined,
        collection_id: config.dataset.collectionId || undefined,
        ...extra,
      };
      if (preview) {
        if (panel) panel.textContent = 'Preview only — not sent\n' + name + '\n' + JSON.stringify(data, null, 2);
        return false;
      }
      if (window.Shopify?.designMode || !allowed()) return false;
      try {
        const publish = window.Shopify?.analytics?.publish;
        if (typeof publish !== 'function') return false;
        const result = publish.call(window.Shopify.analytics, name, data);
        if (result?.catch) result.catch(() => {});
        return result !== false;
      } catch (_) {
        return false;
      }
    };
    const placement = (link) => {
      if (link.matches('[data-main-whatsapp]')) return 'product_main';
      if (link.closest('[data-sticky-whatsapp]')) return 'product_sticky';
      if (link.closest('.mobile-sticky-bar')) return 'mobile_contact_bar';
      if (link.closest('.floating-whatsapp')) return 'floating_button';
      if (link.closest('header')) return 'header';
      if (link.closest('footer')) return 'footer';
      if (link.closest('[data-slide]')) return 'hero';
      if (link.closest('.contact-details')) return 'contact_details';
      if (link.matches('[data-product-enquiry]')) return 'product_secondary';
      if (link.closest('#MainContent')) return 'page_content';
      return 'other';
    };
    const onClick = (event) => {
      if (event.defaultPrevented || (event.type === 'auxclick' ? event.button !== 1 : event.button !== 0)) return;
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      let destination;
      try {
        destination = new URL(link.href, location.origin);
      } catch (_) {
        return;
      }
      let channel;
      if (destination.protocol === 'tel:') channel = 'phone';
      if (destination.protocol === 'https:' && ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(destination.hostname)) channel = 'whatsapp';
      if (!channel) return;
      const last = recentClicks.get(link);
      if (last !== undefined && Date.now() - last < 1000) return;
      recentClicks.set(link, Date.now());
      emit('laserco:' + channel + '_click', { contact_method: channel, placement: placement(link) });
    };
    document.addEventListener('click', onClick);
    document.addEventListener('auxclick', onClick);
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form.matches?.('form.contact-form[id^="EnquiryForm-"]') || !form.checkValidity()) return;
      if (preview || !allowed()) return;
      try {
        sessionStorage.setItem(pendingKey, JSON.stringify({ form_id: form.id, at: Date.now() }));
      } catch (_) {}
    }, true);
    const checkSuccess = () => {
      const success = document.querySelector('[data-enquiry-success]');
      if (!success || preview || !allowed()) return;
      try {
        const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
        if (!pending || pending.form_id !== success.dataset.enquirySuccess) return;
        const age = Date.now() - pending.at;
        sessionStorage.removeItem(pendingKey);
        if (age < 0 || age > 30 * 60 * 1000) return;
        emit('laserco:contact_form_success', { contact_method: 'contact_form', placement: 'contact_form' });
      } catch (_) {}
    };
    document.addEventListener('visitorConsentCollected', () => {
      if (!allowed()) {
        try { sessionStorage.removeItem(pendingKey); } catch (_) {}
      } else {
        checkSuccess();
      }
    });
    if (allowed()) {
      checkSuccess();
    } else if (!preview && typeof window.Shopify?.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) checkSuccess();
        });
      } catch (_) {}
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
